import type { TFunction } from 'i18next';

/**
 * The one place a role is worded. Every page that shows a role — badges, filters, the demo
 * banner — goes through `roleLabel`, so "Admin" reads the same everywhere and in every
 * language. The keys are the role values the backend sends.
 */
const ROLE_LABEL_KEYS: Record<string, string> = {
  super_admin: 'roles.super_admin',
  admin: 'roles.admin',
  trainer: 'roles.trainer',
  trainee: 'roles.trainee',
};

/** The role values that have a label, in display order (for filter options). */
export const LABELLED_ROLES = Object.keys(ROLE_LABEL_KEYS);

/**
 * `role` in the UI language. A role with no label yet is title-cased ("org_owner" ->
 * "Org Owner") rather than shown as the raw value.
 */
export function roleLabel(role: string, t: TFunction): string {
  const key = ROLE_LABEL_KEYS[role];
  if (key) return t(key);
  return role.split('_').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
}
